<template>
  <div class="i-svg-spinners:3-dots-fade" :class="center && 'absolute top-1/2 left-1/2 -translate-1/2'" />
</template>

<script lang="ts" setup>
interface Props {
  center?: boolean
}

defineProps<Props>()
</script>
